import { render, staticRenderFns } from "./BannerView.vue?vue&type=template&id=689131fb&scoped=true"
import script from "./BannerView.vue?vue&type=script&lang=js"
export * from "./BannerView.vue?vue&type=script&lang=js"
import style0 from "./BannerView.vue?vue&type=style&index=0&id=689131fb&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "689131fb",
  null
  
)

export default component.exports